import { baseUrl, useAxios } from "services/rest/request";

export type MakePaymentResponse = {
  success?: boolean;
  /** YooKassa mode: freshly minted confirmation URL to redirect to */
  paymentLink?: string;
};

export function useMakePayment(invoiceId: string) {
  return useAxios<MakePaymentResponse>({
    url: `${baseUrl}/invoices/${invoiceId}/pay`,
    method: "post",
  }, [], false);
}